<template>
  <div class="gallery-download-progress" role="status" aria-live="polite">
    <div class="gallery-download-progress__content">
      <div class="gallery-download-progress__status">
        <span class="gallery-download-progress__label" :title="label">{{ label }}</span>
        <strong v-if="total > 0" class="gallery-download-progress__count">{{ current }} de {{ total }}</strong>
      </div>

      <div
        class="gallery-download-progress__bar"
        role="progressbar"
        :aria-valuenow="current"
        aria-valuemin="0"
        :aria-valuemax="total"
      >
        <span :style="{ width: `${percentage}%` }"></span>
      </div>
    </div>

    <b-spinner small type="border" class="gallery-download-progress__spinner"></b-spinner>
  </div>
</template>

<script>
export default {
  name: "GalleryDownloadProgress",
  props: {
    current: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: "Baixando galeria..."
    }
  },
  computed: {
    percentage() {
      if (this.total <= 0) {
        return 0;
      }
      return Math.min(100, Math.max(0, Math.round((this.current / this.total) * 100)));
    }
  }
};
</script>

<style scoped lang="scss">
.gallery-download-progress {
  width: 260px;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #5e6670;

  &__content {
    min-width: 0;
    flex: 1 1 auto;
  }

  &__status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    line-height: 1.25;
  }

  &__label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
  }

  &__count {
    flex: 0 0 auto;
    color: #343a40;
    font-size: 13px;
    white-space: nowrap;
  }

  &__bar {
    height: 4px;
    margin-top: 6px;
    overflow: hidden;
    border-radius: 4px;
    background: #e4e7eb;

    span {
      display: block;
      height: 100%;
      border-radius: inherit;
      background: #1683f3;
      transition: width .3s ease;
    }
  }

  &__spinner {
    flex: 0 0 auto;
    color: #343a40;
  }
}
</style>
